import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useConfirm from 'src/hooks/useConfirm';
import useDeclineInvoiceApi from 'src/services/useDeclineApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';
import useInvoiceButtonState from './useInvoiceButtonState';

const Decline = () => {
  const { declineInvoice, declineCallLoading } = useDeclineInvoiceApi();
  const { confirm } = useConfirm();
  const title = useContextSelector(InvoiceContext, (value) => value.title);
  const invoiceId = useContextSelector(InvoiceContext, (value) => value.invoiceId);
  const refreshPage = useContextSelector(InvoiceContext, (value) => value.refreshPage);

  const [messages, declineButtonState] = useInvoiceButtonState('Decline');

  const handleDeclineInvoice = useCallback(() => {
    confirm({
      title: `Confirm Decline ${title}`,
      content: <div>Are you sure you want to decline {title}?</div>,
      cancelButtonText: 'Cancel',
      cancelColor: 'info',
      confirmButtonText: 'Yes, Decline',
    }).then(async (isConfirmDeline) => {
      if (isConfirmDeline) {
        declineInvoice({
          invoiceIds: [invoiceId],
        })
          .then((res) => {
            if (isEmpty(res?.unProcessed)) {
              toast.success(`${title} Declined successfully!`);
            }
          })
          .finally(() => {
            refreshPage();
          });
      }
    });
  }, [confirm, declineInvoice, invoiceId, refreshPage, title]);

  return (
    <PopUp
      content={<PopUpContentWrapper contents={messages} type="Error" />}
      show={declineButtonState === 1}
    >
      <Button
        color="error"
        onClick={handleDeclineInvoice}
        loading={declineCallLoading}
        buttonState={declineButtonState}
      >
        Decline
      </Button>
    </PopUp>
  );
};

export default Decline;
